
	export interface IChartOptions {
        background: string,
        foreground: string,
        labelBackground: string,
        labelForeground: string,
        seriesColor: string,
        fontSize: number,
        fontFace: string,
		timeline: {
			color: string,
			strokeWidth: number
		},
        grid: {
            /** Values: 'both' | 'none' | 'horizontal' | 'vertical'. Default is 'both'.
            */
            display: string;
            color: string;
            /**
             * Grid interval set in domain values (e.g major: 1 mV, minor: 0.2 mV)
             */
            interval: {
                x?: {major: number, minor: number},
                y?: {major: number, minor: number}
            };
            /**
             * Grid interval set in PX values (e.g major: 40px, minor: 5px)
             */
            intervalPX: {
                x?: {major: number, minor: number},
                y?: {major: number, minor: number}
            };
            /**
             * Grid hint set in PX values (e.g major: 38px, minor: 38/5px => ~1cm grid with 5 minor steps).
             * The value set in PX may change to form a round domain value (it's just a grid hint).
             */
            hint: {
                x?: {major: number, minor: number},
                y?: {major: number, minor: number}
            }
        },
        format: {
            dateFormat:string,
            timeFormat:string
        }
    }

    export class ChartOptions implements IChartOptions {
        background = '#fff';
        foreground = '#000';
        labelBackground = '#eee';
        labelForeground = '#000';
        seriesColor = 'blue';
        fontSize = 10;
        fontFace = 'Arial';
		timeline = {
			color: "#ccc",
			strokeWidth: 2
		};
        grid = {
            display: 'both',
            color: '#ccc',
            interval: {},
            intervalPX: {},
            hint: {}
        };
        format = {
            dateFormat: 'DD-MM-YYYY',
            timeFormat: 'HH:mm:ss'
        }
    }
